<template>
  <div>
    <ODialog ref="dialog">
      <v-card>
        <ODialogBar title="Formato do relatório" @close="dismiss" />

        <v-card-text class="pa-6">
          <v-expansion-panels v-model="copiedValue" mandatory accordion>
            <v-expansion-panel v-for="item in items" :key="item.code">
              <v-expansion-panel-header>{{
                item.title
              }}</v-expansion-panel-header>
              <v-expansion-panel-content>
                {{ item.description }}
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-card-text>

        <ODialogButtons
          class="pa-6"
          txtApply="OK"
          @cancel="dismiss"
          @apply="apply"
        />
      </v-card>
    </ODialog>

    <!-- NB: BasePicker só emite input qdo clica no clear -->
    <BasePicker
      label="Data"
      icon="mdi-file-multiple-outline"
      :orientation="orientation"
      :value="strValue"
      @input="clear"
      @open="openDialog"
    />
  </div>
</template>

<script>
import BasePicker from 'oderon-vue/cpts/pickers/BasePicker.vue'

const _items = [
  {
    code: 'condensed',
    title: 'Formato condensado',
    description: `
      Todas as linhas de mensalidade e serviços serão colocadas
      em uma única aba.`
  },
  {
    code: 'multisheets1',
    title: 'Em abas',
    description: `
      Cada tipo de equipamento (Oderon Fox, Câmera, e Teclado)
      terá uma aba de Mensalidade e outra aba de Serviços.`
  }
]

export default {
  components: {
    BasePicker
  },
  props: {
    orientation: { type: String, default: 'horizontal' },
    value: {}
  },
  data() {
    return {
      items: _items,
      copiedValue: 0
    }
  },
  computed: {
    strValue() {
      // const horz = this.orientation == 'horizontal'
      if (this.value == null) return this.items[0].title
      let item = this.items.find((x) => x.code == this.value)
      if (item == null) return this.value + '?'
      return item.title
    }
  },
  methods: {
    clear() {
      this.$emit('input', this.items[0].code)
    },

    async openDialog() {
      this.copiedValue = this.items.findIndex((x) => x.code == this.value)
      if (this.copiedValue == -1) this.copiedValue = 0

      let res = await this.$refs.dialog.$open()
      if (res != null) {
        this.$emit('input', res)
      }
    },

    dismiss() {
      this.$refs.dialog.$dismiss()
    },

    apply() {
      let newVal = this.items[this.copiedValue]
      if (newVal == null) newVal = this.items[0]
      this.$refs.dialog.$apply(newVal.code)
    }
  }
}
</script>

<style></style>
